module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.8 50.8"><path d="M38.3 33.3c2.3-3.4 3.7-7.5 3.7-11.9 0-11.6-9.4-21-21-21S0 9.8 0 21.4s9.4 21 21 21c4.8 0 9.3-1.6 12.9-4.4l12.3 12.3 4.6-4.6-12.5-12.4zM21 39.2c-9.8 0-17.8-8-17.8-17.8S11.2 3.6 21 3.6s17.8 8 17.8 17.8-8 17.8-17.8 17.8z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/096-analytics.svg
// module id = 1243
// module chunks = 1